/*
 * @Description:
 * @Autor: gxd
 * @Date: 2020-11-16 14:05:12
 * @LastEditors: gxd
 * @LastEditTime: 2020-11-16 14:27:34
 */
// 字符串转数字，用于版本号比较
const toNumber = (a = '') => {
  a = a.toString()
  // 也可以这样写 var c=a.split(/\./);
  const c = a.split('.')
  const num_place = ['0000', '000', '00', '0', '']
  for (let i = 0; i < c.length; i++) {
    const len = c[i].length
    c[i] = num_place[len] + c[i]
  }
  const res = c.join('')
  return res
}
export default toNumber
